import {
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_SERVICES_MARKETPLACE } from "../domain";

import { servicesMarketplaceApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_SET_SERVICE_NOT_RELEVANT = "SET_SERVICE_NOT_RELEVANT";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const setServiceNotRelevant = async (
  serviceId: number,
): Promise<void> => {
  const response = await servicesMarketplaceApi.serviceMarketplaceControllerSetServiceNotRelevant(serviceId);

  return response.data;
};

export const useSetServiceNotRelevant = (
  user: UserProfileDto | null,
): {
  setServiceNotRelevant: UseMutateFunction<void, Error, number>;
  setServiceNotRelevantEnabled: boolean;
  isSuccessSetServiceNotRelevant: boolean;
  isPendingSetServiceNotRelevant: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_SERVICES_MARKETPLACE, ACTION_SET_SERVICE_NOT_RELEVANT],
    mutationFn: enabled ? setServiceNotRelevant : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_SERVICES_MARKETPLACE] });
    },
  });

  return {
    setServiceNotRelevant: mutate,
    setServiceNotRelevantEnabled: enabled,
    isSuccessSetServiceNotRelevant: isSuccess,
    isPendingSetServiceNotRelevant: isPending,
  };
};
